import DTO from './DTO';
import DateRangeDTO from './DateRangeDTO';
import ListType from './converters/ListType';

const WEEKDAY_VALUE_BY_LABEL = {
  monday: 0,
  mon: 0,
  понедельник: 0,
  tuesday: 1,
  tue: 1,
  вторник: 1,
  wednesday: 2,
  wed: 2,
  среда: 2,
  thursday: 3,
  thu: 3,
  четверг: 3,
  friday: 4,
  fri: 4,
  пятница: 4,
  saturday: 5,
  sat: 5,
  суббота: 5,
  sunday: 6,
  sun: 6,
  воскресенье: 6,
};

const normalizeWeekday = value => {
  if (typeof value === 'number' && Number.isInteger(value)) {
    return value;
  }

  if (typeof value === 'string') {
    const trimmedValue = value.trim();
    if (/^\d+$/.test(trimmedValue)) {
      return Number(trimmedValue);
    }

    const translationKeyMatch = trimmedValue.match(/^weekdays\.(\d)$/);
    if (translationKeyMatch) {
      return Number(translationKeyMatch[1]);
    }

    const labelValue = WEEKDAY_VALUE_BY_LABEL[trimmedValue.toLowerCase()];
    if (typeof labelValue !== 'undefined') {
      return labelValue;
    }
  }

  return value;
};

const normalizeWeekdays = weekdays => (
  (Array.isArray(weekdays) ? weekdays : [])
    .map(normalizeWeekday)
    .filter(value => typeof value === 'number' && Number.isInteger(value) && value >= 0 && value <= 6)
);

const SafeArrayType = value => (Array.isArray(value) ? [...value] : []);

class ScheduleDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'time_ranges',
        type: ListType(DateRangeDTO),
        validators: [],
        labelKey: 'time_ranges',
      },
      {
        name: 'weekdays',
        type: SafeArrayType,
        validators: [],
        labelKey: 'weekdays',
      },
      {
        name: 'exclude_holidays',
        type: Boolean,
        validators: [],
        labelKey: 'exclude_holidays',
      },
      {
        name: 'special_dates',
        type: SafeArrayType,
        validators: [],
        labelKey: 'special_dates',
      },
    ];
    super(attributes, params, isValidInit);
  }

  getData() {
    return {
      time_ranges: this.time_ranges.map(i => i.getData()),
      weekdays: normalizeWeekdays(this.weekdays),
      exclude_holidays: this.exclude_holidays,
      special_dates: this.special_dates,
    };
  }
}

export default ScheduleDTO;
